import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import StepBadge from '../StepBadge';
import RegPerson from '../RegPerson';
import RegVehicle from '../RegVehicle';
import RegLegalPerson from '../RegLegalPerson';
import K from '../../../../../constants';
import { InfoIcon, CheckIcon } from '../../../../../common/icons/redesignIcons';

import './RegCheckData.css';

const ExternalIcon = () => (
  <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M7 17 17 7M8 7h9v9" />
  </svg>
);

@inject('translationsStore')
@observer
class RegCheckData extends Component {
  render() {
    const { translationsStore, withLegal, onConfirm } = this.props;

    return (
      <div className="RegCheckData mv-hero-bg">
        <div className="RegCheckDataInner">
          <div className="RegCheckDataHead">
            <StepBadge number={2} label={translationsStore.translate('movein.stepCheckData.badge')} />
            <h1 className="mv-h1">{translationsStore.translate('movein.stepCheckData.title')}</h1>
            <p className="mv-lead">{translationsStore.translate('movein.stepCheckData.subtitle')}</p>
          </div>

          <div className="mv-amber-banner RegCheckDataBanner">
            <span className="RegCheckDataBannerIcon">
              <InfoIcon size={20} color="var(--amber)" />
            </span>
            <div className="RegCheckDataBannerText">
              <div className="RegCheckDataBannerTitle">{translationsStore.translate('movein.stepCheckData.bannerTitle')}</div>
              <div>{translationsStore.translate('movein.stepCheckData.bannerText')}</div>
            </div>
            <a className="RegCheckDataBannerCta" href={K.MOVEIN_REGION_PORTAL_URL} target="_blank" rel="noopener noreferrer">
              {translationsStore.translate('movein.stepCheckData.bannerCta')}
              <ExternalIcon />
            </a>
          </div>

          <div className="mv-card RegCheckDataCard">
            <div className="RegCheckDataSection">
              <RegPerson />
            </div>
            {withLegal && (
              <div className="RegCheckDataSection">
                <RegLegalPerson />
              </div>
            )}
            <div className="RegCheckDataSection">
              <RegVehicle />
            </div>
            <div className="RegCheckDataFooter">
              <div className="RegCheckDataWrong">
                {translationsStore.translate('movein.stepCheckData.wrongDataPrompt')}{' '}
                <a href={K.MOVEIN_REGION_PORTAL_URL} target="_blank" rel="noopener noreferrer">
                  {translationsStore.translate('movein.stepCheckData.wrongDataLink')}
                </a>
              </div>
              <button className="mv-btn" onClick={onConfirm}>
                <CheckIcon />
                {translationsStore.translate('movein.stepCheckData.confirmCta')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RegCheckData;
